<template>
  <b-modal v-model="show" size="lg" title="" no-close-on-backdrop no-close-on-esc hide-header-close hide-footer>
      <div class="container-fluid">
        <div class="row modal-fix">
          <div class="col-12 text-center">
            <div class="icon-box">
              <h2>!</h2>
            </div>
            <h4 class="w-80">{{errorMsg}}</h4>
            <h4 class="w-80" v-if="errorMsg.includes('Ушбу мулкка оид')">Кадастр рақами тўғри киритилганига ишончингиз комилми? </h4>
          </div>
          <div class="col-12">
            <div class="form-group" v-if="requiredIdent">
              <label>ИНН ёки ЖШШИР<span class="text-danger">*</span></label>
              <pinfl-input
                :pinfl.sync="pinflOrInnNumber"
                :placeholder="'Жисмоний шаҳснинг шаҳсий идентификация рақами (ЖШШИР 14 рақам) ёки ИНН(9 рақам)'"
                :validation-field="$v.pinflOrInnNumber"
              />
            </div>
            <div class="form-group">
              <label>Камчилик сабаби <span class="text-danger">*</span></label>
              <textarea v-model="data.description" class="form-control"></textarea>
              <div class="text-danger" v-if="$v.data.description.$error">
                Камчилик сабабини киритинг
              </div>
            </div>
          </div>
          <div class="col-12 mt-5 d-flex justify-content-end">
            <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t('action.cancel')}} </button>
            <button class="all-btn ml-3  add-btn " :disabled="processing" @click="acceptData">{{$t('realEstate.action.confirm')}}</button>
          </div>
        </div>
      </div>
  </b-modal>
</template>

<script>
import {minLength, required, requiredUnless} from "vuelidate/lib/validators";
  import {TheMask} from 'vue-the-mask';
  import {isValidPinfl} from "@/shared/pinfl-birthdate/pinfl-birthdate";
  import PinflInput from "@/components/common/PinflInput.vue";
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  export default {
    components: {
      'b-modal': bModal,
      PinflInput,
      TheMask
    },
    directives: {
      'b-modal': bModalDirective
    },
    props: {
      errorMsg: {
        type: String,
        default: ''
      },
      requestId: {
        type: String,
        default: null
      },
      evlObjectType: {
        type: String,
        default: null
      },
      requiredIdent: {
         default: true
      },
      senderSource: {
        type: String,
        default: 'OTHER'
      }
    },
    data() {
      return {
        show: false,
        processing: false,
        pinflOrInnNumber: null,
        data: {
          requestId: null,
          pinfl: '',
          tin: '',
          description: '',
          entityName: null
        }
      }
    },
    validations() {
      return {
        pinflOrInnNumber: {
          required: requiredUnless(() => {
            return !this.requiredIdent
          }),
          minLength: minLength(9)
        },
        data: {
          description: {
            required: required,
            minLength: minLength(3)
          }
        }
      }
    },
    methods: {
      acceptData() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        const vm = this

        let pinflOrInnNumberLength = this.pinflOrInnNumber ? this.pinflOrInnNumber.length : 0

        if(pinflOrInnNumberLength > 9 && isValidPinfl(this.pinflOrInnNumber).result) {
          this.data.pinfl = this.pinflOrInnNumber
        } else if (pinflOrInnNumberLength === 9) {
          this.data.tin = this.pinflOrInnNumber
        }

        this.data.requestId = this.$props.requestId
        this.data.evlObjectType = this.$props.evlObjectType
        this.data.senderSource = this.$props.senderSource

        this.processing = true;
        this.$http.post('/v3/real-estate/send-fix-error', this.data).then(res => {
          if (res.status === 200) {
            this.data.pinfl = ''
            this.data.tin = ''
            this.data.description = ''
            this.data.requestId = null
            this.data.entityName = null

            vm.$emit("handle-success", res)
            this.show = false
          }
          vm.processing = false;
        }).catch(({response}) => {
          console.log('error')
          console.log(response)

          this.$swal({
            type: 'error',
            title: '',
            text: response.data.message ? response.data.message : response.data
          });
          vm.processing = false;
          this.show = false
        });
      },
      cancel() {
        this.show = false
      }
    },
    created() {
      this.$eventBus.$on('showCadastreFixErrorModal', () => {
        this.show = true;
      })
    }
  }
</script>

<style scoped>
  .modal-fix {
  }

  .modal-fix h4 {
    text-align: center;
    font-size: 26px;
    font-weight: inherit;
    margin: 30px;
  }

  .modal-fix .icon-box {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    border-radius: 50%;
    z-index: 9;
    text-align: center;
    border: 3px solid #ffa700;
  }

  .modal-fix .icon-box h2 {
    margin: 10px;
    font-size: 3rem;
    font-weight: bold;
    color: #ffa700;
  }
</style>
